import { Button } from '@components/button';
import { useDownloadGraphMutation } from '@generated/graphql';
import { saveFile } from '@helper-functions/save-file';
import { Stack } from '@mui/material';
import { useNotifications } from '@notifications/Notifications';
import yaml from 'js-yaml';

interface DownloadConfigurationModalProps {
  graphId: string;
  name: string;
  workspaceId: string;
  onClose: () => void;
}

export const JobsConfigurationsPreviewOptionsDownloadModal = ({
  graphId,
  name,
  workspaceId,
  onClose,
}: DownloadConfigurationModalProps) => {
  const { addNotification } = useNotifications();
  const [downloadGraph] = useDownloadGraphMutation();

  const fileName = name || graphId || new Date().toISOString();

  const handleDownloadConfigAsJSONClick = async () => {
    onClose();
    const { data: downloadGraphData } = await downloadGraph({
      variables: { graphId, workspaceId },
    });
    const data = downloadGraphData?.downloadGraph || '';
    const fullFileName = `${fileName}.json`;
    const url = window.URL.createObjectURL(new Blob([data]));
    saveFile({ url, name: fullFileName });
    addNotification({
      text: 'Starting download as JSON...',
      type: 'success',
      duration: 6000,
    });
  };

  const handleDownloadConfigAsYAMLClick = async () => {
    onClose();
    const { data: downloadGraphData } = await downloadGraph({
      variables: { graphId, workspaceId },
    });
    const parsedData = downloadGraphData?.downloadGraph || '';
    const data = yaml.dump(JSON.parse(parsedData ?? '{}'), { skipInvalid: true, sortKeys: true });
    const fullFileName = `${fileName}.yaml`;
    const url = window.URL.createObjectURL(new Blob([data], { type: 'text/plain' }));
    saveFile({ url, name: fullFileName });
    addNotification({
      text: 'Starting download as YAML...',
      type: 'success',
      duration: 6000,
    });
  };

  return (
    <Stack gap={4}>
      <Button variant="secondary" fullWidth onClick={handleDownloadConfigAsJSONClick}>
        JSON
      </Button>
      <Button variant="secondary" fullWidth onClick={handleDownloadConfigAsYAMLClick}>
        YAML
      </Button>
    </Stack>
  );
};
